
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4o1J1XB79VrttnUfgOkEpMqXyqk7b4tQRUcM2II401MMeta } from "/builds/brighterly/apps/land-app/pages/index.vue?macro=true";
import { default as quiz15aWR9B3Bf_IecQBqDdQCbBUuLwqDX3Jef7hcoHRGVUyUMeta } from "/builds/brighterly/apps/land-app/pages/quiz15.vue?macro=true";
import { default as afterschool_45quizT2BF2vWyrCTZfzAi1Zmb2XXtU30jIRsv6Uf2pDHA30sMeta } from "/builds/brighterly/apps/land-app/pages/afterschool-quiz.vue?macro=true";
import { default as registration_45quizFW_45rLzCV7gGTlI0dcIaP3XTTyNN465_45Nf1Aq5aMo5VgMeta } from "/builds/brighterly/apps/land-app/pages/registration-quiz.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/builds/brighterly/apps/land-app/pages/index.vue")
  },
  {
    name: "quiz15",
    path: "/quiz15",
    component: () => import("/builds/brighterly/apps/land-app/pages/quiz15.vue")
  },
  {
    name: "afterschool-quiz",
    path: "/afterschool-quiz",
    component: () => import("/builds/brighterly/apps/land-app/pages/afterschool-quiz.vue")
  },
  {
    name: "registration-quiz",
    path: "/registration-quiz",
    component: () => import("/builds/brighterly/apps/land-app/pages/registration-quiz.vue")
  }
]